<template>
  <div>
    <b-modal id="modalEditTelephoneZones" ref="modalEditTelephoneZones" :title="$t('Telephone zones detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.zone_id > 0">
        <b-form-input type="text" disabled v-model="editItem.zone_id"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
        <b-form-invalid-feedback id="inputFeedbackName">
          {{ $t('Enter title') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="listOfTypeTelZones" v-model="editItem.type"/>
      </b-form-group>
      <b-form-group :label="$t('Directions')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.zone_id > 0">
        <b-button variant="success" style="float: right" size="sm" @click="showAddTelDirections">{{ $t('Add') }}</b-button>
      </b-form-group>
      <b-table striped hover v-if="editItem.zone_id > 0"
        :items="editItem.directions"
        :fields="directionsFields">
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="ClickOnDeleteDirectionsButton(row)" id="transparent">
            <b-img :src='deleteImage'/>
          </b-button>
        </template>
      </b-table>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditTelephoneZones.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="modalAddTelephoneDirections" id="modalAddTelephoneDirections" hide-footer :title="$t('Telephone directions')">
        <b-table striped hover id="tablereport" responsive
        :items="telDirectionsItems"
        :fields="telDirectionsFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTerDir">
        </b-table>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTelDirections">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$bvModal.hide('modalAddTelephoneDirections')">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      listOfTypeTelZones: [
        {text: this.$i18n.t('Local coverage'), value: 0},
        {text: this.$i18n.t('Innerzone coverage'), value: 1},
        {text: this.$i18n.t('Intercity coverage'), value: 2},
        {text: this.$i18n.t('International coverage'), value: 3}
      ],
      selectTelDir: null,
      deleteImage: require('@/assets/img/document_delete.png'),
      directionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'zones', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix'), sortable: true},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix'), sortable: true}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      if (this.editItem.directions.length > 0) {
        for (let el of this.editItem.directions) {
          el.zone_id = this.editItem.zone_id
          el.type = this.editItem.type
          let response = this.$store.dispatch('Tariffing/UPDATE_TEL_DIRECTIONS', el)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            }
          })
        }
      }
      let response = this.editItem.zone_id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_TEL_ZONES', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_TEL_ZONES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_ZONES')
          this.$refs.modalEditTelephoneZones.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    rowClickTerDir (row) {
      this.selectTelDir = row
    },
    showAddTelDirections () {
      this.selectTelDir = null
      this.$refs.modalAddTelephoneDirections.show()
    },
    ClickOnDeleteDirectionsButton (row) {
      this.editItem.directions = this.editItem.directions.filter((value) => {
        return value !== row.item
      })
    },
    addTelDirections () {
      if (!this.selectTelDir) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      for (let el of this.editItem.directions) {
        if (el.dir_id === this.selectTelDir.dir_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
          return
        }
      }
      this.editItem.directions.push(this.selectTelDir)
      this.$refs.modalAddTelephoneDirections.hide()
    }
  },
  computed: {
    telDirectionsItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST']))
      for (let el of copy) {
        el.create_date = moment(Number(el.create_date) * 1000).format('YYYY-MM-DD hh:mm')
        if (el.update_date) {
          el.updateDate = moment(Number(el.update_date) * 1000).format('YYYY-MM-DD hh:mm')
        } else {
          el.updateDate = this.$i18n.t('Not installed')
        }
        for (let elZone of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))) {
          if (el.zone_id === elZone.zone_id) {
            el.zones = elZone.name + ' (' + elZone.zone_id + ')'
            break
          }
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/telephone/telephoneZones/editModal.vue